import { useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { FEATURES_DATA } from '../../data/features';
import styles from './Features.module.css';

export default function Features() {
    const { t } = useLanguage();
    const [activeTab, setActiveTab] = useState('design');

    const tabs = ['design', 'performance', 'innovation'];
    const currentData = FEATURES_DATA[activeTab];

    return (
        <section className={styles.featuresSection}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <h2 className={styles.sectionTitle}>{t(currentData.titleKey)}</h2>

                    <div className={styles.tabs}>
                        {tabs.map(tab => (
                            <button
                                key={tab}
                                className={`${styles.tabBtn} ${activeTab === tab ? styles.active : ''}`}
                                onClick={() => setActiveTab(tab)}
                            >
                                {t(`features.tabs.${tab}`)}
                            </button>
                        ))}
                    </div>
                </div>

                <div className={styles.content} key={activeTab}>
                    <div className={styles.grid}>
                        {currentData.cards.map((card, index) => (
                            <div key={index} className={styles.card}>
                                <div className={styles.imageWrapper}>
                                    <img
                                        src={card.image}
                                        alt={t(card.titleKey)}
                                        className={styles.image}
                                    />
                                </div>
                                <h3 className={styles.cardTitle}>{t(card.titleKey)}</h3>
                                <p className={styles.cardDesc}>{t(card.descKey)}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
